declare namespace $ {

	export class $mol_icon_gesture_tap extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=tap.view.tree.d.ts.map